// 此文件只做组件拓展方法
import numeral from 'numeral'

const type = new Map([
  [1, '信用限额'],
  [2, '正常额度'],
  [3, '临时额度'],
  [4, '专项额度'],
  [5, '信用限额 + 正常额度'],
  [6, '信用限额 + 临时额度'],
  [7, '信用限额 + 专项额度'],
  ['default', ''],
])

export default {
  install(Vue) {
    /**
     * 表单 v-decorator 方法扩展
     * @param id: v-decorator的id属性
     * @param errorMessage: 如不在options设置相应的验证，只需添加必填的相应错误提示即可
     * @param rules: 继续扩展多个rules验证方式
     * @param options v-decorator的options属性
     * @returns {[*, {rules: [{message: *, required: boolean}]}]}
     */
    Vue.prototype.$decorator = (
      id,
      errorMessage,
      rules = [{ required: true, message: errorMessage }],
      options = {},
    ) => {
      return [
        id,
        {
          rules,
          ...options,
        },
      ]
    }
    Vue.prototype.$formatAppAmount = arr => {
      let str = ''
      if (arr.length > 0) {
        arr.map(
          item =>
            (str += `<div>${type.get(item.type)} : ${numeral(
              item.amount,
            ).format('0,0')}</div>`),
        )
      }
      return str
    }

    Vue.prototype.$formatStrList2Arr = str => {
      if (str) {
        let arr = str.split(',')
        return arr.map(item => {
          return item === 'NA' ? 'NA' : numeral(item).format('0,0')
        })
      } else {
        return ''
      }
    }
  },
}
